var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	34458: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	74125: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	5246: {
		fallback: () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	6204: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.4.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	7333: {
		fallback: () => (Promise.all([__webpack_require__.e(523), __webpack_require__.e(458)]).then(() => (() => (__webpack_require__(33523))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.1.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	8679: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	37114: {
		fallback: () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(83533))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.12.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/rbac",
	},
	52561: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.41",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	90837: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	93586: {
		fallback: () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(87069))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.20.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"125": [
		74125
	],
	"458": [
		34458
	],
	"958": [
		5246,
		6204,
		7333,
		8679,
		37114,
		52561,
		90837,
		93586
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}